import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
  const routes = [
    {
      path: "/",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    },
    {
      path: "/home",
      name: "Home",
      component: () =>
        import(/* webpackChunkName: "home" */ "../views/Home.vue"),
      children: [
        {
          //Vista donde estan los graficos
          path: "/massive",
          component: () =>
            import(/* webpackChunkName: "Dash" */ "../views/Masive.vue"),
        },
        {
          //Demo carpeta Storage
          path: "/storage",
          component: () =>
            import(
              /* webpackChunkName: "Instituciones" */ "../views/storage/index.vue"
            ),
        },
        {
          //Dashboard
          path: "/dashboard",
          component: () =>
            import(
              /* webpackChunkName: "Dashboard" */ "../views/Dashboard.vue"
            ),
        },
        {
          //Master de Reportes
          path: "/reportes",
          component: () =>
            import(
              /* webpackChunkName: "Evaluacion" */ "../views/Reportes.vue"
            ),
        },

        {
          //Master de Reportes
          path: "/kits",
          component: () =>
            import(
              /* webpackChunkName: "Evaluacion" */ "../views/kits/list.vue"
            ),
        },
        {
          //Master de Reportes
          path: "/workgroups",
          component: () =>
            import(
              /* webpackChunkName: "Evaluacion" */ "../views/Workgroups.vue"
            ),
        },
        {
          //Módulo de products
          path: "/products",
          component: () =>
            import(
              /* webpackChunkName: "Products" */ "../views/products/list-products.vue"
            ),
        },
        {
          //Programas de aseo
          path: "/suppliers",
          component: () =>
            import(
              /* webpackChunkName: "Programas de Aseo" */ "../views/Suppliers.vue"
            ),
        },
        {
          //Programas de aseo
          path: "/categories",
          component: () =>
            import(
              /* webpackChunkName: "Programas de Aseo" */ "../views/Categories.vue"
            ),
        },
        {
          //Programas de aseo
          path: "/inventories-zone",
          component: () =>
            import(
              /* webpackChunkName: "Programas de Aseo" */ "../views/inventoryzones/list.vue"
            ),
        },
        {
          //Programas de aseo
          path: "/movements",
          component: () =>
            import(
              /* webpackChunkName: "Programas de Aseo" */ "../views/movements/list.vue"
            ),
        },
        {
          //Programas de aseo
          path: "/deliveries",
          component: () =>
            import(
              /* webpackChunkName: "Programas de Aseo" */ "../views/deliveries/list.vue"
            ),
        },
        {
          //Master de Reportes
          path: "/empleados",
          component: () =>
            import(
              /* webpackChunkName: "Evaluacion" */ "../views/employees/list.vue"
            ),
        },
        {
          //Vista donde estan los graficos
          path: "/usuarios",
          component: () =>
            import(/* webpackChunkName: "Dash" */ "../views/SysUser.vue"),
        },
      ],
    },
    {
      path: "/login",
      name: "Log",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    },
    {
      path: "/recovery",
      name: "Recovery",
      component: () =>
        import(/* webpackChunkName: "recovery" */ "../views/Recovery.vue"),
    },
    {
      path: "/barcode",
      name: "Barcode",
      component: () =>
        import(/* webpackChunkName: "barcode" */ "../views/Barcode.vue"),
    },
  ];

const router = new VueRouter({
  routes
})

export default router
